import { DollarSign, TrendingUp } from "lucide-react";

const fmt = (v) => `R$ ${(Number(v) || 0).toFixed(2).replace(".", ",")}`;

/** Os 3 cards da ficha padrao (Custo Total | CMV % · Margem | Lucro), com um
 *  valor por TAMANHO dentro de cada card. `custo` e `preco`: {size_id: numero}. */
export default function CardsResumo({ sizes, custo, preco }) {
  const linhas = sizes.map((sz) => {
    const c = Number(custo[sz.id]) || 0, p = Number(preco?.[sz.id]) || 0;
    return { sz, c, p, lucro: p - c, cmv: p > 0 ? (c / p) * 100 : null, margem: p > 0 ? ((p - c) / p) * 100 : null };
  });
  const pior = Math.max(0, ...linhas.map((l) => l.cmv ?? 0));
  const cmvTom = pior <= 30 ? "emerald" : pior <= 50 ? "amber" : "red";
  const tom = {
    emerald: ["text-emerald-600 dark:text-emerald-400", "bg-emerald-100 dark:bg-emerald-900/30"],
    amber: ["text-amber-600 dark:text-amber-400", "bg-amber-100 dark:bg-amber-900/30"],
    red: ["text-red-600 dark:text-red-400", "bg-red-100 dark:bg-red-900/30"],
  }[cmvTom];
  const algumLucro = linhas.some((l) => l.p > 0 && l.lucro > 0), algumPrejuizo = linhas.some((l) => l.p > 0 && l.lucro < 0);
  const lucroCls = algumPrejuizo ? "text-red-600 dark:text-red-400" : algumLucro ? "text-blue-600 dark:text-blue-400" : "text-gray-400";
  const lucroBg = algumPrejuizo ? "bg-red-100 dark:bg-red-900/30" : algumLucro ? "bg-blue-100 dark:bg-blue-900/30" : "bg-gray-100 dark:bg-gray-900/30";

  const Linha = ({ sz, children }) => (
    <div className="flex items-baseline justify-between gap-3">
      <span className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">{sz.name}</span>
      <span className="tabular-nums">{children}</span>
    </div>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-e2e="cards-resumo">
      <div className="bg-card rounded-xl border p-4 flex items-center gap-3" data-e2e="card-custo">
        <div className="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center flex-shrink-0">
          <DollarSign className="w-5 h-5 text-purple-600 dark:text-purple-400" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] text-muted-foreground font-medium">Custo Total</p>
          {linhas.map((l) => <Linha key={l.sz.id} sz={l.sz}><span className="text-base font-bold text-purple-600 dark:text-purple-400">{fmt(l.c)}</span></Linha>)}
        </div>
      </div>
      <div className="bg-card rounded-xl border p-4 flex items-center gap-3" data-e2e="card-cmv">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${tom[1]}`}>
          <TrendingUp className={`w-5 h-5 ${tom[0]}`} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] text-muted-foreground font-medium">CMV % · Margem</p>
          {linhas.map((l) => (
            <Linha key={l.sz.id} sz={l.sz}>
              <span className={`text-base font-bold ${tom[0]}`}>{l.cmv == null ? "—" : `${l.cmv.toFixed(1).replace(".", ",")}%`}</span>
              <span className="text-muted-foreground/60 mx-1">·</span>
              <span className={`text-base font-bold ${l.margem == null ? "text-muted-foreground" : l.margem >= 50 ? "text-emerald-600 dark:text-emerald-400" : l.margem >= 30 ? "text-amber-600 dark:text-amber-400" : "text-red-600 dark:text-red-400"}`}>
                {l.margem == null ? "—" : `${l.margem.toFixed(1).replace(".", ",")}%`}
              </span>
            </Linha>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-xl border p-4 flex items-center gap-3" data-e2e="card-lucro">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${lucroBg}`}>
          <DollarSign className={`w-5 h-5 ${lucroCls}`} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] text-muted-foreground font-medium">Lucro <span className="text-muted-foreground/60">(por tamanho)</span></p>
          {linhas.map((l) => <Linha key={l.sz.id} sz={l.sz}><span className={`text-base font-bold ${l.p > 0 ? (l.lucro < 0 ? "text-red-600 dark:text-red-400" : "text-blue-600 dark:text-blue-400") : "text-gray-400"}`}>{l.p > 0 ? fmt(l.lucro) : "—"}</span></Linha>)}
        </div>
      </div>
    </div>
  );
}
